import { createSlice } from '@reduxjs/toolkit';

interface UserManagementState {
  provisionModalOpen: boolean;
}

const initialState: UserManagementState = {
  provisionModalOpen: false,
};

const userManagementSlice = createSlice({
  name: 'userManagement',
  initialState,
  reducers: {
    openProvisionModal(state) {
      state.provisionModalOpen = true;
    },
    closeProvisionModal(state) {
      state.provisionModalOpen = false;
    },
  },
});

export const { openProvisionModal, closeProvisionModal } = userManagementSlice.actions;

export default userManagementSlice.reducer;
